import { Breakpoints, Spacing } from '@doordash/design-language';
import { ContentPadding } from './constants';
export var breakpointForScreenWidth = function breakpointForScreenWidth(windowWidth) {
  var windowBreakpoint = 'Mobile';

  if (windowWidth >= Breakpoints.Desktop) {
    windowBreakpoint = 'Desktop';
  }

  if (windowWidth >= Breakpoints.Tablet && windowWidth < Breakpoints.Desktop) {
    windowBreakpoint = 'Tablet';
  }

  return windowBreakpoint;
};
export var getModalPadding = function getModalPadding(usesDynamicBreakpoint, windowBreakpoint) {
  if (usesDynamicBreakpoint && ContentPadding.hasOwnProperty(windowBreakpoint)) {
    return ContentPadding[windowBreakpoint];
  }

  return Spacing.Small;
};